/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2023-04-14 13:30:08
 * @LastEditTime: 2025-11-21 11:28:27
 */
import { Modal } from "antd";
import { useEffect, useState } from "react";
import { getEnv } from "../../../helpers/mobx-easy-wrapper";
import ActivityRouter from "../../routers/activity-router";

const Enter = () => {

    const [collegeFlag, setCollegeFlag] = useState(true);
    const [visible, setVisible] = useState(true);
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        setCollegeFlag(window.location.href.indexOf('college') > 0)
        const { apiFactory } = getEnv();
        const loginFlag = apiFactory.authService.isAuthenticated();
        setIsLogin(loginFlag);
    }, [isLogin])

    const handleCancel = () => {
        setVisible(false);
        // window.localStorage.setItem('report', '1');
    };

    return (
        <div className="home" style={{ width: '1200px', margin: '0 auto' }}>
            <div className="jury__line outlineTitle" style={{ textAlign: "center" }}>
                <label className={`enter_label  ${collegeFlag ? 'active' : ''}`} onClick={() => (window.location.href = "/enter/college")} >初创组</label>
                <div className={`split__line`}></div>
                <label className={`enter_label  ${!collegeFlag ? 'active' : ''}`} onClick={() => (window.location.href = "/enter/enterprise")} >成长组</label>
            </div>
            {visible && isLogin && (
                <Modal
                    wrapClassName={'enter_modal'}
                    visible={true}
                    centered={true}
                    closable={false}
                    footer={[
                        <button
                            key={'closeButton'}
                            type='button'
                            className={'lite__sub__button'}
                            onClick={handleCancel}
                        >
                            我已阅读并同意
                        </button>,
                    ]}
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<p style="text-align: center;"><strong>报名须知</strong></p>
    <p style="text-indent: 24pt;color:rgba(0, 0, 0, .85);">1、参赛项目要求</p>
    <p style="text-indent: 24pt;">本届“龙知交赛”以技术领先、市场潜力大、落地转化前景好的战略性产业集群高价值专利为参赛对象。</p>
    <p style="text-indent: 24pt;">（1）本届大赛参赛项目分为初创组、成长组。其中，高校院所参赛项目列入初创组。参赛企业按2024年汇算清缴的营业收入进行分组，营业收入300万元人民币以下（含）的列入初创组，营业收入300万元人民币以上的列入成长组。</p>
    <p style="text-indent: 24pt;">若参赛主体为多个企业联合参赛或高校院所与企业联合参赛，则按参赛企业的2024年汇算清缴的营业收入总和计算。</p>
    <p style="text-indent: 24pt;">（2）参赛项目应当是具有至少一项核心技术（含基础技术、重要技术分支）的专利。参赛项目拥有多件专利的，应明确其中一件专利为参赛核心专利。</p>
    <p style="text-indent: 24pt;">（3）参赛项目的核心专利应在有效期内，且无知识产权纠纷，《专利转化运用专项行动方案（2023—2025年）》以来形成的专利产业化优先。除参赛核心专利之外，参赛主体应该将与参赛项目关系最密切且能够形成专利组合的不超过10个发明专利、实用新型专利、外观设计专利一起参赛。</p>
    <p style="text-indent: 24pt;">（4）参赛项目所属专利技术领域应以黑龙江省“4567”现代化产业体系为主。</p>
    <p style="text-indent: 24pt;">（5）已获得过国家级、省级专利奖的项目，不得报名参加比赛。</p>
    <p style="text-indent: 24pt;color:rgba(0, 0, 0, .85);">2、参赛主体（团队）要求</p>
    <p style="text-indent: 24pt;">（1）参赛项目必须由核心专利的权利人（之一）报名参加。如果参赛主体为核心专利的多个权利人之一的，参赛事项应获得其他权利人的书面同意。</p>
    <p style="text-indent: 24pt;">（2）参赛团队成员可包括参赛主体在册员工。一经报名，参赛团队成员不可变更，参赛主体成员若发生变更，应报大赛执委会并在“黑龙江科技成果和知识产权交易平台”官网公示后更换。大赛中上场答辩的人员，必须是已报名的参赛团队成员。</p>
    <p style="text-indent: 24pt;">（3）同一企业报名参赛项目不得超过3个，高校院所不受报名数量限制。</p>
    <p style="text-indent: 24pt;">（4）出现非正常专利申请现象的参赛主体，取消其获奖资格。</p>
    <p style="text-indent: 24pt;color:rgba(0, 0, 0, .85);">3、报名承诺</p>
    <p style="text-indent: 24pt;">报名方承诺对所填写内容及递交材料的真实性、合法性承担责任。</p>
    <p style="text-indent: 24pt;color:rgba(0, 0, 0, .85);">4、项目推广</p>
    <p style="text-indent: 24pt;">报名方同意大赛组委会对本项目在大赛官方渠道开展项目推广。</p>`,
                        }}
                    />
                </Modal>
            )}
            <ActivityRouter />
        </div>
    );
}

export default Enter;